/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signed_In_DevicesInputs */

const th_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อุปกรณ์ที่คุณเข้าสู่ระบบ`)
};

const en_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where you're signed in`)
};

const ja_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログイン中の端末`)
};

const zh_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你已登录的位置`)
};

const es_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dónde tienes la sesión iniciada`)
};

const pt_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde você está conectado`)
};

const id_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat Anda masuk`)
};

const fr_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où vous êtes connecté`)
};

const tl_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kung saan ka naka-sign in`)
};

const vi_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nơi bạn đang đăng nhập`)
};

const ko_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인되어 있는 곳`)
};

const de_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo du angemeldet bist`)
};

const ru_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Где выполнен вход`)
};

const tr_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oturumunuzun açık olduğu yerler`)
};

const it_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dove hai una sessione aperta`)
};

const pl_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gdzie jesteś zalogowany`)
};

const uk_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Де відкрито сесію`)
};

const hi_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप कहाँ साइन इन हैं`)
};

const ar_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أين سجّلت الدخول`)
};

const ms_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat anda log masuk`)
};

const bn_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনি কোথায় সাইন ইন আছেন`)
};

const zh_tw2_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你已登入的位置`)
};

const zh_hk2_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你已登入的位置`)
};

const ur_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کہاں سائن اِن ہیں`)
};

const fa_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاهایی که وارد شده‌اید`)
};

const sw_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahali ulipoingia`)
};

const nl_signed_in_devices = /** @type {(inputs: Signed_In_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar je bent ingelogd`)
};

/**
* | output |
* | --- |
* | "Where you're signed in" |
*
* @param {Signed_In_DevicesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const signed_in_devices = /** @type {((inputs?: Signed_In_DevicesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signed_In_DevicesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_signed_in_devices(inputs)
	if (locale === "ja") return ja_signed_in_devices(inputs)
	if (locale === "zh") return zh_signed_in_devices(inputs)
	if (locale === "es") return es_signed_in_devices(inputs)
	if (locale === "pt") return pt_signed_in_devices(inputs)
	if (locale === "id") return id_signed_in_devices(inputs)
	if (locale === "fr") return fr_signed_in_devices(inputs)
	if (locale === "tl") return tl_signed_in_devices(inputs)
	if (locale === "vi") return vi_signed_in_devices(inputs)
	if (locale === "ko") return ko_signed_in_devices(inputs)
	if (locale === "de") return de_signed_in_devices(inputs)
	if (locale === "ru") return ru_signed_in_devices(inputs)
	if (locale === "tr") return tr_signed_in_devices(inputs)
	if (locale === "it") return it_signed_in_devices(inputs)
	if (locale === "pl") return pl_signed_in_devices(inputs)
	if (locale === "uk") return uk_signed_in_devices(inputs)
	if (locale === "hi") return hi_signed_in_devices(inputs)
	if (locale === "ar") return ar_signed_in_devices(inputs)
	if (locale === "ms") return ms_signed_in_devices(inputs)
	if (locale === "bn") return bn_signed_in_devices(inputs)
	if (locale === "zh-TW") return zh_tw2_signed_in_devices(inputs)
	if (locale === "zh-HK") return zh_hk2_signed_in_devices(inputs)
	if (locale === "ur") return ur_signed_in_devices(inputs)
	if (locale === "fa") return fa_signed_in_devices(inputs)
	if (locale === "sw") return sw_signed_in_devices(inputs)
	if (locale === "nl") return nl_signed_in_devices(inputs)
	return en_signed_in_devices(inputs)
});